var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIpadLandscape = function SvgIpadLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M0 5.515v12.968C0 19.762 1.12 20.8 2.5 20.8h19c1.38 0 2.5-1.037 2.5-2.316V5.515c0-1.278-1.12-2.316-2.5-2.316h-19C1.12 3.2 0 4.237 0 5.515m23 6.484c0 .77-.67 1.39-1.5 1.39s-1.5-.62-1.5-1.39.67-1.39 1.5-1.39S23 11.23 23 12m-4-6.947v13.895H3V5.052z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M7 11.398h1.6v4.8H7zM10.2 9h1.6v7.2h-1.6zM13.401 13h1.6v3.2h-1.6z"
  })));
};
export default SvgIpadLandscape;